var _style, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 605.5 281.4",
    style: {
      enableBackground: "new 0 0 605.5 281.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 249.4,
    cy: 147.5,
    rx: 46,
    ry: 20.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,112L6,110.3c-4.7-1.7-7.1-6.8-5.5-11.5c0.3-0.8,0.7-1.5,1.1-2.2c11.5-15.9,42.5-47.1,117.2-66 c1.5-0.4,2.9-1.1,4-2.2l17.5-16.6c1.2-1.1,2.7-1.9,4.3-2.3c9.9-2.2,49-9.6,114.6-9.6c76.6,0,156.4,11.5,230.4,53.6 c0,0,36.2,22.1,48.6,47s22.8,30.7,25.4,30.7h33c5,0,9,4,9,9l0,0c0,5-4,9-9,9h-33c0,0-11.3-0.1-20.5,20s-33.9,59.3-102.8,83.3 s-134.4,28.7-156,28.7h-55.8c-1.9,0-3.7-0.6-5.2-1.7l-15-10.8c-1.3-1-2.9-1.5-4.5-1.7c-11-0.9-56.2-5-89.7-16.4 c-4.7-1.6-7.2-6.8-5.5-11.5c0.1-0.4,0.3-0.7,0.4-1.1l2.5-4.9c1.9-3.9,6.4-5.8,10.5-4.6c16.8,4.8,63,15.8,134.4,15.8 c91.3,0,216.6-45.6,216.6-105.4S339.8,36.4,238.6,36.4c-98.5,0-169.5,24.5-218.5,73.5C17.7,112.3,14.1,113.2,10.8,112z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalo);
export default __webpack_public_path__ + "static/media/halo.2dbb7eacd2a868d942bbf773b766161a.svg";
export { ForwardRef as ReactComponent };